import { EmblaCarouselType } from 'embla-carousel';
import { EmblaEventType } from 'embla-carousel/components/EventHandler';
const TWEEN_FACTOR_BASE = 0.5;
let tweenFactor = 0;

const numberWithinRange = (number: number, min: number, max: number) => Math.min(Math.max(number, min), max);

const getTweenNodes = (emblaApi: EmblaCarouselType) => {
  let tweenNodes: HTMLElement[] = [];
  tweenNodes = emblaApi.slideNodes().map((slideNode) => {
    return slideNode as HTMLElement;
  });
  return tweenNodes;
};

const setTweenFactor = (emblaApi: EmblaCarouselType) => {
  tweenFactor = window.innerWidth < 768 ? 0 : TWEEN_FACTOR_BASE * emblaApi.scrollSnapList().length;
};

const tweenScale = (emblaApi: EmblaCarouselType, event: EmblaEventType) => {
  const engine = emblaApi.internalEngine();
  const scrollProgress = emblaApi.scrollProgress();
  const slidesInView = emblaApi.slidesInView();
  const isScrollEvent = event?.type === 'scroll';
  const tweenNodes: HTMLElement[] = getTweenNodes(emblaApi);

  emblaApi.scrollSnapList().forEach((scrollSnap, snapIndex) => {
    let diffToTarget = scrollSnap - scrollProgress;
    if (isScrollEvent && !slidesInView.includes(snapIndex)) return;

    if (engine.options.loop) {
      engine.slideLooper.loopPoints.forEach((loopItem) => {
        const target = loopItem.target();
        if (snapIndex === loopItem.index && target !== 0) {
          const sign = Math.sign(target);

          if (sign === -1) {
            diffToTarget = scrollSnap - (1 + scrollProgress);
          }
          if (sign === 1) {
            diffToTarget = scrollSnap + (1 - scrollProgress);
          }
        }
      });
    }

    const tweenValue = 1 - Math.abs(diffToTarget * tweenFactor);
    const scale = numberWithinRange(tweenValue, 0, 1).toString();
    const tweenNode = tweenNodes[snapIndex];

    const selected = emblaApi.selectedScrollSnap();
    const beforeNumber = selected === 0 ? emblaApi.scrollSnapList().length - 1 : selected - 1;
    const afterNumber = emblaApi.scrollSnapList().length - 1 === selected ? 0 : selected + 1;
    if (afterNumber === snapIndex) {
      tweenNode.classList.add('is-after');
      tweenNode.classList.remove('is-before');
    } else if (beforeNumber === snapIndex) {
      tweenNode.classList.remove('is-after');
      tweenNode.classList.add('is-before');
    } else {
      tweenNode.classList.remove('is-after');
      tweenNode.classList.remove('is-before');
    }

    const imgNode = tweenNode.querySelector('img') as HTMLElement;
    imgNode.style.scale = `${scale}`;
  });
};

export const setupTweenScale = (emblaApi: EmblaCarouselType) => {
  setTweenFactor(emblaApi);
  tweenScale(emblaApi);
  emblaApi.on('reInit', setTweenFactor).on('reInit', tweenScale).on('scroll', tweenScale).on('slideFocus', tweenScale);
};
